module.exports = __webpack_public_path__ + "img/cover-2.62707757.png";